export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40b6ea6582433604ec8290d6ff7977708689131666&name=revalidateCommunity!'